export default __webpack_public_path__ + "static/emp-icn5-f52f7439113c0b09ec9dcf4e70a99dcd.png";